var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 341,
    height: 209.937,
    viewBox: "0 0 341 209.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_159",
    "data-name": "Groupe 159",
    transform: "translate(0.02 -0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_646",
    "data-name": "Trac\\xE9 646",
    d: "M352.07,222.147a69.876,69.876,0,0,1-2.047,16.861q-.689,2.785-1.6,5.46a65.046,65.046,0,0,1-2.582,6.462q-.738,1.6-1.56,3.133A42.151,42.151,0,0,1,340.756,271a43.676,43.676,0,0,1-21.187,21.829,44.585,44.585,0,0,1-18.937,4.343H75.808a56.649,56.649,0,0,1-28.494-7.614q-1.919-1.112-3.741-2.368a56.572,56.572,0,0,1-7.4-6.1,55.088,55.088,0,0,1-8.138-10.1,53.809,53.809,0,0,1-8.277-28.728,67.749,67.749,0,0,1-8.685-33.549A66.483,66.483,0,0,1,24.506,168.02a57.206,57.206,0,0,1,5.706-6.349,53.1,53.1,0,0,1,6.526-5.342,50.363,50.363,0,0,1,5.79-3.474c.837-.428,1.676-.828,2.53-1.2.75-.333,1.508-.643,2.276-.935q1.381-.527,2.8-.964t2.794-.77q2.027-.5,4.123-.8c1.158-.171,2.316-.29,3.474-.382q1.381-.1,2.785-.116h.507c1.031,0,2.056.041,3.072.11.107-.214.223-.431.33-.646.405-.77.825-1.54,1.248-2.3v-.02c.072-.13.145-.261.22-.388.342-.617.7-1.228,1.063-1.833.168-.29.333-.562.5-.837.038-.067.075-.13.119-.2q.261-.434.53-.869,1.34-2.139,2.788-4.212c.084-.119.162-.235.246-.35.151-.214.29-.426.457-.637.4-.559.811-1.12,1.225-1.673.29-.391.579-.782.892-1.158q1.129-1.459,2.316-2.9c.79-.955,1.624-1.917,2.467-2.857.116-.13.232-.258.353-.388l1.236-1.346h0c.061-.064.113-.122.171-.18h0c.148-.159.29-.318.449-.475.663-.7,1.343-1.393,2.027-2.076a110.361,110.361,0,0,1,11.129-9.67c.153-.122.31-.237.463-.353.735-.556,1.482-1.1,2.229-1.642a117.786,117.786,0,0,1,12.857-8.02c.307-.174.62-.339.935-.5a123.406,123.406,0,0,1,12.3-5.663q3.434-1.358,6.989-2.536c1.569-.512,3.144-1,4.739-1.448q3.7-1.063,7.493-1.917a134.147,134.147,0,0,1,22.652-3.086q3.474-.182,7.026-.182a134.624,134.624,0,0,1,33.873,4.285,1.222,1.222,0,0,0,1.051.547h.973c.423.113.842.232,1.265.353q3.541,1.022,6.98,2.226l.579.208a124.606,124.606,0,0,1,16.476,7.238,119.3,119.3,0,0,1,13.8,8.523q1.016.73,2,1.474,1.2-.773,2.438-1.474a47.942,47.942,0,0,1,10.1-4.3,46.061,46.061,0,0,1,22.651-.886A50.122,50.122,0,0,1,311.9,119.946a59.218,59.218,0,0,1,7.62,9.635c.159.249.318.5.472.756A63.694,63.694,0,0,1,324.838,140c.049.122.1.24.142.362a66.9,66.9,0,0,1,2.982,9.655c.035.165.075.333.11.5a69.517,69.517,0,0,1,1.424,9.661,1.831,1.831,0,0,0,.023.353q.182,2.522.185,5.1c0,1.534-.052,3.057-.148,4.566,0,.165-.023.339-.038.507-.026.44-.064.869-.1,1.311a54.924,54.924,0,0,1,6.19,5.837q1.265,1.381,2.449,2.869a60.845,60.845,0,0,1,6.311,9.661A68.01,68.01,0,0,1,352.07,222.147Z",
    transform: "translate(-11.09 -87.42)",
    fill: "#f18815",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_647",
    "data-name": "Trac\\xE9 647",
    d: "M400.436,661.694c0,6.581-6.821,12.739-18.723,18.042H156.889c-10.4,0-20.144-3.764-28.494-10.327a11.98,11.98,0,0,1-3.2-7.718c0-6.995,7.713-13.523,21.048-19.041h0l.376-.151c3.764-1.543,7.97-3,12.568-4.369.116-.035.235-.067.35-.107h0q5.472-1.607,11.641-3.046c.13-.029.258-.061.388-.084,1.587-.376,3.2-.727,4.858-1.077h0l.637-.133a362.762,362.762,0,0,1,40.532-5.819h.017q3.115-.289,6.3-.518c2.36-.188,4.748-.347,7.163-.5,1.844-.119,3.712-.22,5.585-.313a.055.055,0,0,1,.043,0c8.451-.426,17.183-.649,26.111-.649a481.022,481.022,0,0,1,61.438,3.764.148.148,0,0,1,.052,0c2.843.371,5.634.761,8.355,1.178.779.122,1.555.243,2.316.368q4.606.744,8.975,1.572h0C378.19,639.283,400.436,649.818,400.436,661.694Z",
    transform: "translate(-92.171 -469.982)",
    fill: "#f18815",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_648",
    "data-name": "Trac\\xE9 648",
    d: "M740.166,211.551s-3.063-1.242-12.808,3.225-10.961,3.9-13.483,3.231-3.929-.845-6.633-4.577c0,0-1.908-10.339-3.764-11.942s-9.69.915-9.69.915-9.406,2.157-11.2-10.422c0,0,1.271-9.473-.46-12.38,0,0,3.5,1.505,9.264-.926s10.385,2.62,10.385,2.62,1.448,3.764,1.3,6.01.77,3.089,3.521,2c0,0,1.352-1.922-.562-5.1s-3.28-5.544-2.747-8.011a9.95,9.95,0,0,1,7.006-7.6c4.936-1.711,11.638-2.027,14.855-3.379s4.01-2.215,4.01-2.215-1.98,1.983,2.684,10.394,1.691,12.058,1.691,12.058-2.481,5.915-13.436,5.434c0,0-10.556.385-4.8,4.861,0,0,3.685-.75,9.195-2.5s9.487,5.478,10.475,10.506A13.242,13.242,0,0,0,740.166,211.551Z",
    transform: "translate(-487.869 -141.105)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_649",
    "data-name": "Trac\\xE9 649",
    d: "M813.175,184.957l.058-.017c.423,1.6-4.293,8.054-8.326,13.182l-.046-.038C810.546,190.863,813.5,186.2,813.175,184.957Z",
    transform: "translate(-575.068 -156.693)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_650",
    "data-name": "Trac\\xE9 650",
    d: "M776.934,230l.026.064c-3.222,4.094-7.272,8.975-10.515,12.6-.31.345-.617.706-.912,1.077l-.093-.075c.289-.371.605-.735.915-1.08C769.594,238.975,773.708,234.1,776.934,230Z",
    transform: "translate(-547.06 -188.707)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_651",
    "data-name": "Trac\\xE9 651",
    d: "M747.337,276.89l.064.11c-5.9,7.368-6.291,18.818-6.306,18.908l-1.245-1.448C739.865,294.368,741.4,284.31,747.337,276.89Z",
    transform: "translate(-528.879 -222.022)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_652",
    "data-name": "Trac\\xE9 652",
    d: "M746.267,257.617s-6.948-3.619-12.38-2.316-17.646-4.6-17.646-4.6-5.182-2.1-6.224-4.5c0,0-3.558-3.764-3.764-5.706s-3.665-6.838-5.923-7.026",
    transform: "translate(-500.8 -191.166)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_653",
    "data-name": "Trac\\xE9 653",
    d: "M847.794,316.383s-3.5-2.362-3.095-5.113",
    transform: "translate(-603.349 -246.449)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_654",
    "data-name": "Trac\\xE9 654",
    d: "M823.411,317.492s-5.011-1.818-5.5-8.952",
    transform: "translate(-584.339 -244.509)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_655",
    "data-name": "Trac\\xE9 655",
    d: "M800.356,319.055a11.213,11.213,0,0,1-3.2-10.915",
    transform: "translate(-569.365 -244.225)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_656",
    "data-name": "Trac\\xE9 656",
    d: "M771.667,312.049s-3.185-6.688-.35-11.039",
    transform: "translate(-550.401 -239.159)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_657",
    "data-name": "Trac\\xE9 657",
    d: "M851.979,301.67s-3.622,1.158-2.846,3.057",
    transform: "translate(-606.445 -239.628)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_658",
    "data-name": "Trac\\xE9 658",
    d: "M831.952,279s-4.849,1.537-4.962,8.4",
    transform: "translate(-590.791 -223.521)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_659",
    "data-name": "Trac\\xE9 659",
    d: "M810.689,273.48s-4.415,5.449-4.091,10.4",
    transform: "translate(-576.29 -219.599)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_660",
    "data-name": "Trac\\xE9 660",
    d: "M784.564,280.86s-4.383,4.192-3.824,6.523",
    transform: "translate(-557.895 -224.843)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_661",
    "data-name": "Trac\\xE9 661",
    d: "M773.437,274.244s-4.111.735-4.687-.614",
    transform: "translate(-549.412 -219.706)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_662",
    "data-name": "Trac\\xE9 662",
    d: "M766.49,258.61s2.076,2.75,2.606,2.134",
    transform: "translate(-547.806 -209.034)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_663",
    "data-name": "Trac\\xE9 663",
    d: "M806.42,246.774s-10.365.753-12.71-2.374",
    transform: "translate(-567.146 -198.938)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_664",
    "data-name": "Trac\\xE9 664",
    d: "M759,210.73s4.861,10.437,8.4,11.766",
    transform: "translate(-542.485 -175.016)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_665",
    "data-name": "Trac\\xE9 665",
    d: "M776.58,193.56s2.985,9.6,6.685,12.6",
    transform: "translate(-554.975 -162.817)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_666",
    "data-name": "Trac\\xE9 666",
    d: "M821.721,225.131s-7.88,3.382-12.611-.041",
    transform: "translate(-578.087 -185.219)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_667",
    "data-name": "Trac\\xE9 667",
    d: "M800.82,186.49s1.8,7.055,4.227,8.761",
    transform: "translate(-572.197 -157.794)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_668",
    "data-name": "Trac\\xE9 668",
    d: "M833.64,197.92s-4.43,1.679-6.08.394",
    transform: "translate(-591.196 -165.915)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_669",
    "data-name": "Trac\\xE9 669",
    d: "M749.273,266.57s0,6.152-1.673,6.589",
    transform: "translate(-534.385 -214.69)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_670",
    "data-name": "Trac\\xE9 670",
    d: "M706.09,287.073s6.659.579,9.719-2.863",
    transform: "translate(-504.893 -227.223)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_671",
    "data-name": "Trac\\xE9 671",
    d: "M732.611,241.47s-1.61,6.239-6.051,7.921",
    transform: "translate(-519.436 -196.857)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_672",
    "data-name": "Trac\\xE9 672",
    d: "M692.31,265.19a8.712,8.712,0,0,0,8.758-2.53",
    transform: "translate(-495.102 -211.912)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_673",
    "data-name": "Trac\\xE9 673",
    d: "M721.214,222.94s-.443,5.3-3.324,7.779",
    transform: "translate(-513.276 -183.691)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_674",
    "data-name": "Trac\\xE9 674",
    d: "M692.93,240.448s3.906.026,4.82-1.248",
    transform: "translate(-495.543 -195.244)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 111.231,
    height: 56.148,
    transform: "translate(114.404 65.322)",
    fill: "#33323d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 180.882,
    height: 36.959,
    transform: "translate(79.755 138.528)",
    fill: "#33323d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_675",
    "data-name": "Trac\\xE9 675",
    d: "M376.705,510.35h92.751l18.48,62.19H357.16Z",
    transform: "translate(-253.772 -362.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_676",
    "data-name": "Trac\\xE9 676",
    d: "M257.73,402.33v58.991h34.649V427.208H414.27v34.113h34.649V402.33Z",
    transform: "translate(-183.128 -285.836)",
    fill: "#504f60"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 191.189,
    height: 19.189,
    transform: "translate(74.602 116.494)",
    fill: "#33323d",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 2.843,
    cy: 2.843,
    r: 2.843,
    transform: "translate(252.644 123.248)",
    fill: "#8ccf4d",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 2.843,
    cy: 2.843,
    r: 2.843,
    transform: "translate(239.85 123.248)",
    fill: "#fa5959",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 103.058,
    height: 61.122,
    transform: "translate(118.492 51.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_677",
    "data-name": "Trac\\xE9 677",
    d: "M786.383,564.785c.217,2.365-1.569,4.661-1.048,6.977.11.5.324.964.4,1.448.214,1.375-.605,2.678-1.39,3.83l-6.725,9.9a6.141,6.141,0,0,1-.961,1.187c-1.288,1.158-3.216,1.025-4.9,1.366a8.419,8.419,0,0,0-3.286,1.448.214.214,0,0,0-.043.289,2.828,2.828,0,0,0,2.443,1.158c.177.232,0,.579-.243.741-.362.249-.869.316-.929.929a1.019,1.019,0,0,0,.122.617,1.914,1.914,0,0,0,1.178.816c2.316.712,4.844-.538,6.586-2.241s2.994-3.85,4.7-5.585c.947-.958,2.027-1.78,3-2.71a33.675,33.675,0,0,0,4.922-6.369,7,7,0,0,0,1.065-2.168c.18-.77.1-1.584.307-2.348a8.676,8.676,0,0,1,1.613-2.635,8.7,8.7,0,0,0,1.833-5.68,5.44,5.44,0,0,0-3.321-4.71,2.979,2.979,0,0,0-1.862-.113,4.416,4.416,0,0,0-1.9,1.508l-1.277,1.474a3.558,3.558,0,0,0-.744,1.132,1.178,1.178,0,0,0,.263,1.257",
    transform: "translate(-549.156 -423.758)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_678",
    "data-name": "Trac\\xE9 678",
    d: "M786.383,564.785c.217,2.365-1.569,4.661-1.048,6.977.11.5.324.964.4,1.448.214,1.375-.605,2.678-1.39,3.83l-6.725,9.9a6.141,6.141,0,0,1-.961,1.187c-1.288,1.158-3.216,1.025-4.9,1.366a8.419,8.419,0,0,0-3.286,1.448.214.214,0,0,0-.043.289,2.828,2.828,0,0,0,2.443,1.158c.177.232,0,.579-.243.741-.362.249-.869.316-.929.929a1.019,1.019,0,0,0,.122.617,1.914,1.914,0,0,0,1.178.816c2.316.712,4.844-.538,6.586-2.241s2.994-3.85,4.7-5.585c.947-.958,2.027-1.78,3-2.71a33.675,33.675,0,0,0,4.922-6.369,7,7,0,0,0,1.065-2.168c.18-.77.1-1.584.307-2.348a8.676,8.676,0,0,1,1.613-2.635,8.7,8.7,0,0,0,1.833-5.68,5.44,5.44,0,0,0-3.321-4.71,2.979,2.979,0,0,0-1.862-.113,4.416,4.416,0,0,0-1.9,1.508l-1.277,1.474a3.558,3.558,0,0,0-.744,1.132,1.178,1.178,0,0,0,.263,1.257",
    transform: "translate(-549.156 -423.758)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_679",
    "data-name": "Trac\\xE9 679",
    d: "M833.7,778.045a7.781,7.781,0,0,1-5.009.741c-.29-.032-.6-.052-.776.159-.255.31.046.761.356,1.01a7.451,7.451,0,0,0,3.442,1.416,23.283,23.283,0,0,0,3.364.223,57.014,57.014,0,0,0,9.195-.339,1.242,1.242,0,0,0,.5-.148.929.929,0,0,0,.379-.579,2.283,2.283,0,0,0-.8-2.186,6.929,6.929,0,0,0-2.145-1.158l-2.669-1.039a6.887,6.887,0,0,0-2.316-.842C835.978,775.4,834.759,777.426,833.7,778.045Z",
    transform: "translate(-591.38 -576.137)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_680",
    "data-name": "Trac\\xE9 680",
    d: "M833.7,778.045a7.781,7.781,0,0,1-5.009.741c-.29-.032-.6-.052-.776.159-.255.31.046.761.356,1.01a7.451,7.451,0,0,0,3.442,1.416,23.283,23.283,0,0,0,3.364.223,57.014,57.014,0,0,0,9.195-.339,1.242,1.242,0,0,0,.5-.148.929.929,0,0,0,.379-.579,2.283,2.283,0,0,0-.8-2.186,6.929,6.929,0,0,0-2.145-1.158l-2.669-1.039a6.887,6.887,0,0,0-2.316-.842C835.978,775.4,834.759,777.426,833.7,778.045Z",
    transform: "translate(-591.38 -576.137)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_681",
    "data-name": "Trac\\xE9 681",
    d: "M849.585,625.094c-1.109,1.479-2.261,3.185-1.986,5.017a11.149,11.149,0,0,0,1.106,2.771,19.52,19.52,0,0,1,1.12,3.891c.417,1.937.834,3.879,1.089,5.845.29,2.221-1.071,8.645-1.2,10.883a2.3,2.3,0,0,1-.469,1.511c-.148.153-.345.29-.408.478a.8.8,0,0,0,.087.562,6.231,6.231,0,0,0,3.335,3.069,26.456,26.456,0,0,0,6.436,1.691,1.218,1.218,0,0,0,.605-.081,1.158,1.158,0,0,0,.469-.536c1.118-2.134.043-9.731.061-12.142,0-2.027.489-4.007.4-6.016-.072-1.613-.5-3.185-.66-4.794a28.252,28.252,0,0,1,.712-7.889c.37-1.995.741-3.992,1.216-5.967a11.5,11.5,0,0,1,1.288-3.474c.524-.831,1.236-1.523,1.836-2.316a10.422,10.422,0,0,0,2.053-7.637c-.035-.266-3.856.97-4.189,1.115a13.118,13.118,0,0,0-3.732,2.4,33.944,33.944,0,0,0-2.354,2.91q-1.642,2-3.24,4.027Q851.348,622.743,849.585,625.094Z",
    transform: "translate(-605.404 -458.636)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_682",
    "data-name": "Trac\\xE9 682",
    d: "M849.585,624.84c-1.109,1.479-2.261,3.185-1.986,5.02a11.171,11.171,0,0,0,1.106,2.768,19.574,19.574,0,0,1,1.12,3.891c.417,1.937.834,3.879,1.089,5.845.29,2.221-1.071,8.648-1.2,10.886a2.3,2.3,0,0,1-.469,1.508c-.148.153-.345.289-.408.478a.813.813,0,0,0,.087.579,6.226,6.226,0,0,0,3.335,3.066,25.488,25.488,0,0,0,6.436,1.207,1.219,1.219,0,0,0,.605-.081,1.158,1.158,0,0,0,.469-.536c1.118-2.134.043-9.247.061-11.656,0-2.027.489-4.01.4-6.019-.072-1.613-.5-3.185-.66-4.794a28.222,28.222,0,0,1,.712-7.886c.37-2,.741-4,1.216-5.97a11.5,11.5,0,0,1,1.288-3.474c.524-.828,1.236-1.523,1.836-2.3a10.443,10.443,0,0,0,2.053-7.637c-.035-.269-3.856.967-4.189,1.115a13.045,13.045,0,0,0-3.732,2.409,36.668,36.668,0,0,0-2.354,2.9q-1.642,2-3.24,4.03Q851.348,622.5,849.585,624.84Z",
    transform: "translate(-605.404 -458.478)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 6.233,
    cy: 6.233,
    r: 6.233,
    transform: "translate(225.589 121.418)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_683",
    "data-name": "Trac\\xE9 683",
    d: "M816.639,524.466a8.089,8.089,0,0,0,5.174,3.619l-.469,1.7c-.811,2.933-1.737,6.033-3.987,8.066a3.777,3.777,0,0,0-.634-2.915,11.176,11.176,0,0,0-2.116-2.212L811.02,529.6a1.072,1.072,0,0,1-.269-.289.93.93,0,0,1,0-.683c.457-1.422,1.763-2.316,2.82-3.271a10.025,10.025,0,0,0,1.419-1.653C815.724,522.682,816.167,523.7,816.639,524.466Z",
    transform: "translate(-579.206 -397.075)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_684",
    "data-name": "Trac\\xE9 684",
    d: "M779.642,494.4l-.139-1.158c.984.255,1.917-.579,2.545-1.448s1.213-1.888,2.171-2.247c1.158-.44,2.4.263,3.509.842a11.114,11.114,0,0,0,4.03,1.317,2.608,2.608,0,0,1,.666.11,2.3,2.3,0,0,1,1.172,1.989,7.67,7.67,0,0,0,.434,2.435c.269.556.735.97,1.019,1.517.761,1.476.026,3.492.831,4.939l-2-1.833c-.185-.168-.443-.342-.643-.2s-.171.356-.237.55a1.045,1.045,0,0,1-1.422.518,3.893,3.893,0,0,1-1.271-1.158,7.735,7.735,0,0,0-3.185-2.4,4.07,4.07,0,0,0-3.355.2c-.932.527-1.615,1.754-2.756,1.8-1.566.058-2.218-2.857-2.944-4.01a1.419,1.419,0,0,0,.411-1.769C778.608,494.346,779.622,494.216,779.642,494.4Z",
    transform: "translate(-556.034 -373.017)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_685",
    "data-name": "Trac\\xE9 685",
    d: "M859.776,775.777a6.59,6.59,0,0,1-4.482,1.67c-.42,0-1,.081-1,.5a.672.672,0,0,0,.122.347,4.12,4.12,0,0,0,2.316,1.812,8.231,8.231,0,0,0,2.8.18l2.736-.142c.515-.029,1.034-.055,1.549-.119s1.071-.171,1.61-.249a21.066,21.066,0,0,1,3.984-.188,1.182,1.182,0,0,0,.981-.266c.22-.266.1-.747.02-1.132-.162-.793,0-1.624-.151-2.42a4.261,4.261,0,0,0-2.791-2.973c-1.23-.469-3.413-1-4.58-.226C861.632,773.411,860.879,774.778,859.776,775.777Z",
    transform: "translate(-610.187 -573.917)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_686",
    "data-name": "Trac\\xE9 686",
    d: "M869.074,609c.243,1.158,1.352,2.027,1.387,3.185a5.017,5.017,0,0,1-1.126,2.533,16.782,16.782,0,0,0-1.158,2.606,39.843,39.843,0,0,1-3.381,6.7,5.322,5.322,0,0,0-1.213,3.318,4.97,4.97,0,0,0,.579,1.587l1.925,3.824a11,11,0,0,1,.984,2.417c.165.727.182,1.479.289,2.221.3,2.345,1.4,4.707.756,6.98-.058.2-.261.434-.414.29a7.221,7.221,0,0,1,1.1,3.732,5.132,5.132,0,0,0,.02,2.1,2.283,2.283,0,0,1,.29.828c0,.191-.09.373-.11.579a1.238,1.238,0,0,0,.961,1.158c.518.165,1.077.159,1.6.316a9.615,9.615,0,0,1,2.577,1.76,5.416,5.416,0,0,0,2.959.964.741.741,0,0,0,.434-.087.706.706,0,0,0,.243-.53,2.935,2.935,0,0,0-1.06-2.551,1.178,1.178,0,0,1-.391-.411.985.985,0,0,1-.038-.46,34.368,34.368,0,0,0-.113-6.317,9.55,9.55,0,0,1-.1-2.009,7.811,7.811,0,0,0,.162-1.673,8.957,8.957,0,0,0-.512-1.6,11.5,11.5,0,0,1-.246-2.982,26,26,0,0,0-.845-5.13,3.836,3.836,0,0,0-.8-1.853c-.4-.417-1.045-.819-.895-1.375a1.594,1.594,0,0,1,.365-.547,2.2,2.2,0,0,0,.46-1.676.747.747,0,0,0,.868-.405,13.48,13.48,0,0,0,6.775-7.7,2.56,2.56,0,0,1,.29-.686,3.13,3.13,0,0,1,1.239-.8,9.4,9.4,0,0,0,3.26-3.321,7.712,7.712,0,0,0,1.256-2.412,7.911,7.911,0,0,0,.174-1.737l.078-3.017a1.625,1.625,0,0,0-.058-.579,1.4,1.4,0,0,0-.324-.478,5.811,5.811,0,0,0-3.185-1.737c-.822-.148-1.662-.119-2.493-.188a31.645,31.645,0,0,0-4.818-.515,7.706,7.706,0,0,0-5.987,4.186C870.415,608.306,869.975,609,869.074,609Z",
    transform: "translate(-616.775 -453.932)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_687",
    "data-name": "Trac\\xE9 687",
    d: "M827.133,538.785a3.31,3.31,0,0,1-.182,1.372.96.96,0,0,1-1.126.579c.13-.289-.217-.634-.539-.6a1,1,0,0,0-.712.605,2.247,2.247,0,0,0-.206,1.393,5.627,5.627,0,0,1,.353,1.737c-.072.492-.434.984-.24,1.448a2.347,2.347,0,0,0,.463.556,1.569,1.569,0,0,1-.165,2.157l4.858.1a3.432,3.432,0,0,0,.6,2.365,14.9,14.9,0,0,0,11.1,7.238.97.97,0,0,0-.232,1.479,1.368,1.368,0,0,0,1.557.087,11.393,11.393,0,0,0,1.338-1,4.085,4.085,0,0,1,2.745-.741c.608.058,1.2.255,1.809.29,1.8.1,3.347-1.2,5.069-1.737,1.262-.388,2.69-.388,3.764-1.175a1.493,1.493,0,0,0,.7-1.448,2.4,2.4,0,0,0-.524-.851,14.426,14.426,0,0,1-1.4-2.632,15.773,15.773,0,0,0-3.512-4.7,31.531,31.531,0,0,0-3.474-2.643,6.119,6.119,0,0,0-.944-.579,9.888,9.888,0,0,1-1.291-.524,6.539,6.539,0,0,1-1.338-1.505c-.964-1.123-2.443-1.641-3.63-2.525a8.906,8.906,0,0,0-2.449-1.659c-.46-.139-.953-.151-1.416-.29-1.048-.318-1.812-1.251-2.843-1.627a12.072,12.072,0,0,0-2.577-.327,5.953,5.953,0,0,1-2.643-1,3.185,3.185,0,0,0-.869-.5c-1.3-.4-1.407,2.027-1.529,2.869A25.86,25.86,0,0,0,827.133,538.785Z",
    transform: "translate(-588.904 -403.331)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_688",
    "data-name": "Trac\\xE9 688",
    d: "M794.223,573.575c.217,2.365-1.569,4.658-1.048,6.977.11.5.324.964.4,1.448.217,1.375-.605,2.678-1.39,3.827l-6.725,9.872a6.147,6.147,0,0,1-.961,1.187c-1.288,1.158-3.216,1.025-4.9,1.366a8.441,8.441,0,0,0-3.286,1.448.214.214,0,0,0-.043.289,2.82,2.82,0,0,0,2.443,1.158c.177.234,0,.579-.243.741-.362.252-.869.318-.929.932a1.02,1.02,0,0,0,.122.617,1.925,1.925,0,0,0,1.178.816c2.316.712,4.844-.539,6.586-2.241s2.994-3.851,4.708-5.585c.947-.958,2.027-1.781,3-2.71a34.16,34.16,0,0,0,4.922-6.369,7.038,7.038,0,0,0,1.065-2.168c.18-.77.1-1.584.307-2.348a8.641,8.641,0,0,1,1.613-2.635,8.7,8.7,0,0,0,1.833-5.68,5.44,5.44,0,0,0-3.321-4.71,2.959,2.959,0,0,0-1.862-.113,4.432,4.432,0,0,0-1.9,1.508l-1.277,1.474a3.5,3.5,0,0,0-.741,1.132,1.172,1.172,0,0,0,.261,1.254",
    transform: "translate(-554.726 -429.986)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_689",
    "data-name": "Trac\\xE9 689",
    d: "M839.461,549.582a3.694,3.694,0,0,0-2.484.77,3.567,3.567,0,0,0-.625.979,9.787,9.787,0,0,0-1.239,3.9,18.435,18.435,0,0,0,.449,3.263,11.974,11.974,0,0,1-.289,2.739,19.042,19.042,0,0,0,3.541-1.361,11.718,11.718,0,0,1,2.07-1.077c1.057-.35,2.831.252,3.827.747.055-.706-.472-1.931-.417-2.637a2.985,2.985,0,0,1,.156-.869,5.336,5.336,0,0,1,.53-.843,3.451,3.451,0,0,0-.31-4.053,5.565,5.565,0,0,0-3.613-1.532,15.672,15.672,0,0,0-2.525-.09",
    transform: "translate(-596.56 -415.711)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_690",
    "data-name": "Trac\\xE9 690",
    d: "M283.1,367.39l-5.709-8.28a7.8,7.8,0,0,0-.481-2.527c-.373-.478-.081-1.543-.081-1.543s.4-.579.055-.64-.055-1.358-.055-1.358l-.026-2.076a7.283,7.283,0,0,0,.055-2.475.785.785,0,0,1,.026-.854s.318-1.144,0-1.448-.24-2.076-.162-3.489a5.3,5.3,0,0,0-.559-2.42c0-.211-2.108-2.29-2.108-2.478a5.115,5.115,0,0,0-2.137-1.158c-.8-.2-1.2-.373-1.173-.481s-1.254-.53-1.254-.53a2.532,2.532,0,0,1-1.549-.64c-.428-.559-1.737-.721-1.769-.727l-.026-.11a.6.6,0,0,0-.023-.122,5.61,5.61,0,0,0,.29-.521l.075-.162a2.264,2.264,0,0,0,1.311-.408,1.775,1.775,0,0,0,.64-1.277,2.791,2.791,0,0,0-.313-1.419,2.376,2.376,0,0,1-.457-1.5c.052-.223.185-.42.255-.64a1.691,1.691,0,0,0-.191-1.262c-.2-.385-.483-.727-.709-1.1a4.343,4.343,0,0,1-.565-1.558,2.4,2.4,0,0,0-.206-.848,1.583,1.583,0,0,0-.469-.472,4.684,4.684,0,0,0-2.869-.869,14.036,14.036,0,0,1-2.171.13,7.78,7.78,0,0,1-1.268-.33,3.271,3.271,0,0,0-2.707.139c-.779.512-1.089,1.52-1.618,2.316a16.836,16.836,0,0,0-1.505,2.027v-.041a2.427,2.427,0,0,0-.2.536,3.816,3.816,0,0,0,.119,1.766,1.227,1.227,0,0,0,.431.787,2.489,2.489,0,0,0,.932.185l-.035.151a6.094,6.094,0,0,0,4.23,7.087v.162a3.872,3.872,0,0,1-.029.457h0s-2.684-.553-3.4-.179-2.134.666-2.348.869-.747.055-1.228,1.306-.533,2.527-1.158,3.115-.932.984-.961,1.41.081.533-.159.666-.579.692-.481.906a.756.756,0,0,1-.29.8.886.886,0,0,0-.373.8s-.162.579-.536.721-.614,1.01-.614,1.01l-1.21,1.39-2.4-2.652a1.013,1.013,0,0,0-1.427-.072l-1.178,1.06a2.333,2.333,0,0,0-1.178.7,3.138,3.138,0,0,0-.611.909l-.643.579a1.642,1.642,0,0,0-.168,1.809l1.537,1.7v.014a2.721,2.721,0,0,0-1.485.605c-2.293,2.027-2.316,3.888-1.974,4.739a35.038,35.038,0,0,0,3.254,4.126,12.989,12.989,0,0,0,4.131,3.364h0l-.017.02a2.011,2.011,0,0,0-.142.165l-.041.052-.038.052-.043.064a.5.5,0,0,0-.032.052l-.046.075a.461.461,0,0,0-.029.052c-.02.035-.038.069-.055.1a.38.38,0,0,0-.017.035c-.023.046-.046.093-.067.145l-.023.052c-.014.035-.026.069-.041.107a.648.648,0,0,0-.023.069l-.035.1a.575.575,0,0,0-.023.075.631.631,0,0,1-.032.116c-.009.041-.014.046-.02.072s-.029.125-.041.191a.146.146,0,0,1-.014.075.693.693,0,0,0-.023.136.372.372,0,0,0,0,.1l-.017.13v.1a.542.542,0,0,1-.014.151c-.014.052,0,.061,0,.093v.258a14.743,14.743,0,0,0,.13,3.567,1.737,1.737,0,0,0,1.416,1.063,1.767,1.767,0,0,0,.455-.023c1.39-.24,4.632-.8,5.79-.579a9.954,9.954,0,0,0,2.878-.234l.24-.046.165.53.527-.145.449.258.289.165c.527,1.783,2.664,1.175,2.664,1.175l.507.29,5.15.133a10.333,10.333,0,0,0,1.824.869,1.406,1.406,0,0,0,.258.058,11.452,11.452,0,0,0,1.448.026c.394,0,.7-.026.7-.026s-.052-1.4-.127-2.965a42.019,42.019,0,0,0,4.771-.391c2.75-.481,3.9-2.982,4.32-4.32a12.624,12.624,0,0,1,.269,1.659,12.025,12.025,0,0,0,.428,1.448,4.828,4.828,0,0,0,.579,1.065c2.027-.692.8-1.737.373-2.183s.289-.825.289-.825.562-.373.507-.718-.081-.718,1.737-.692S283.1,367.39,283.1,367.39Zm-28.175-17a13.812,13.812,0,0,0,.5,2.223,2.894,2.894,0,0,1,.061.869c-1.074-.087-2.194-.133-2.194-.133a.272.272,0,0,1,.058.136l-.171-.038-.243-.058,1.98-3.014ZM251,356.635l1.862.289.156.023a6.081,6.081,0,0,0-.1.869c0,.029.041.061.1.1a2.292,2.292,0,0,0-.035.443,5.162,5.162,0,0,0,1.9.727c-.014.055-.026.107-.041.153h0c-.883-.463-2.27-.68-2.429-1.025s-4.884-1.995-4.884-1.995l-.469-.234,1.242.234.342-.035A18.451,18.451,0,0,0,251,356.635Z",
    transform: "translate(-171.361 -253.774)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_691",
    "data-name": "Trac\\xE9 691",
    d: "M293.621,459.272s-.738,4.47-4.493,5.13-16.291.53-16.291.53-7.168-1.034-9.759-7.087-4.259-8.465-2.027-8.57,14.2,4.053,14.89,4.1S294.284,444.171,293.621,459.272Z",
    transform: "translate(-187.957 -344.498)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_692",
    "data-name": "Trac\\xE9 692",
    d: "M293.621,459.272s-.738,4.47-4.493,5.13-16.291.53-16.291.53-7.168-1.034-9.759-7.087-4.259-8.465-2.027-8.57,14.2,4.053,14.89,4.1S294.284,444.171,293.621,459.272Z",
    transform: "translate(-187.957 -344.498)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_693",
    "data-name": "Trac\\xE9 693",
    d: "M259.671,484.36a1.711,1.711,0,0,0,1.4,1.057,1.916,1.916,0,0,0,.455-.026c1.375-.237,4.6-.793,5.738-.579a9.955,9.955,0,0,0,2.849-.232c.6-.113,1.039-.22,1.039-.22s-1.06-3.518-1.19-3.622-4.763-2.9-4.763-2.9l-3.665-.263h0a1.937,1.937,0,0,0-1.245.73,3.925,3.925,0,0,0-.741,2.5A14.591,14.591,0,0,0,259.671,484.36Z",
    transform: "translate(-187.623 -364.61)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_694",
    "data-name": "Trac\\xE9 694",
    d: "M259.7,484.4a1.711,1.711,0,0,0,1.4,1.057,15.572,15.572,0,0,1-1-1.448l.02-2.565a4.528,4.528,0,0,1,1.448-3.807h0s-1.931.13-1.986,3.225A15.585,15.585,0,0,0,259.7,484.4Z",
    transform: "translate(-187.647 -364.652)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_695",
    "data-name": "Trac\\xE9 695",
    d: "M309.7,461.918l3.413-2.672,5.368-5.289-1.448-.067c-.217.139-.825.579-.848,1.106-.026.646-1.448.046-2.192.414s-4.363,5.009-5,4.977-1.138-.321-1.4.13l-.017.029Z",
    transform: "translate(-221.749 -347.778)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_696",
    "data-name": "Trac\\xE9 696",
    d: "M262.11,478.3c.122.058.246.116.371.168a23.5,23.5,0,0,1,6.031,3.862,25.163,25.163,0,0,0,3.431,2.229c.6-.113,1.039-.22,1.039-.22s-1.06-3.518-1.19-3.622-4.762-2.9-4.762-2.9l-3.665-.263h0a1.937,1.937,0,0,0-1.254.741Z",
    transform: "translate(-189.451 -364.596)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_697",
    "data-name": "Trac\\xE9 697",
    d: "M236.88,440.81a35.156,35.156,0,0,0,3.225,4.1,12.488,12.488,0,0,0,4.418,3.474,22.889,22.889,0,0,1,6.028,3.862,27.832,27.832,0,0,0,3.674,2.371l.327.191.721.42.382.217s.886-.709,1.769-1.424,1.737-1.416,1.737-1.448.371-.979.29-1.031-.223-.394-.559-.819a3.728,3.728,0,0,0-1.346-1.112,3.836,3.836,0,0,1-1.737-1.821s-.116-.084-.29-.2a3.583,3.583,0,0,0-1.187-.53c-.579-.072-1.668-1.262-1.668-1.262a3.237,3.237,0,0,1-1.031-1.083c-.29-.579-4.38-3.4-4.76-3.659l9.942,6.387,2.38,1.529,3.413-2.669,5.368-5.289-1.772-.081c-2.606-.113-7.238-.29-7.817-.156a4.543,4.543,0,0,1-1.448.1,5.126,5.126,0,0,1-2.195-.4c-.874-.46-2.25-.677-2.409-1.019s-4.838-1.98-4.838-1.98-6.369-3.384-8.648-1.375S236.536,439.958,236.88,440.81Z",
    transform: "translate(-171.412 -334.683)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_698",
    "data-name": "Trac\\xE9 698",
    d: "M308.24,367.658l.819,2.724,1.06,6.135,3.888.263,1.112-1.853,1.123-1.864s.7-2.478,1.2-4.875c.443-2.122.735-4.183.252-4.406-.431-.2-.712-.912-.9-1.682-.023-.093-.043-.191-.061-.29a15.236,15.236,0,0,1-.261-1.972s-8.144-.423-7.006,2.936a5.359,5.359,0,0,1,.307,1.786,2.336,2.336,0,0,1-.029.455A3.807,3.807,0,0,1,308.24,367.658Z",
    transform: "translate(-222.225 -280.943)",
    fill: "#ee8e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_699",
    "data-name": "Trac\\xE9 699",
    d: "M302.4,379.947l.29,4.632.66,3.94.741,1.827.663,9.982s6.369.738,7.927-.014a.66.66,0,0,0,.289-.217c1.873-2.829,1.259-11.022,1.259-11.022l.712-5.289-.475-2.745-1.158-.122-.886-.1s-.2.246-.489.628c-.785,1.034-2.226,3.072-2.128,3.92.13,1.158-.159,2.354-.611,2.539s-.819.5-.9.185a1.421,1.421,0,0,1-.081-.845,6.874,6.874,0,0,0-.345-1.827,7.685,7.685,0,0,1-.66-2.3,2.727,2.727,0,0,0-.29-1.668c-.211-.185-.5-.371-.266-1.216s-1.042-2.493-1.042-2.493Z",
    transform: "translate(-218.076 -293.682)",
    fill: "#e3e8f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_700",
    "data-name": "Trac\\xE9 700",
    d: "M331.461,384.208l.266,7.907,1.526.848a.686.686,0,0,0,.289-.22c1.873-2.829,1.259-11.022,1.259-11.022l.715-5.289-.478-2.745-1.158-.122c.446-2.122.735-4.181.252-4.406-.431-.2-.712-.912-.895-1.679h0l-.825,5.593s.069.5.093,1.025a2.894,2.894,0,0,1-.067.984,3.285,3.285,0,0,0-.052,1.323,10.738,10.738,0,0,0-.831,3.9C331.4,382.3,331.461,384.208,331.461,384.208Z",
    transform: "translate(-238.716 -286.385)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_701",
    "data-name": "Trac\\xE9 701",
    d: "M333.625,367s1.335.165,1.757.721a2.5,2.5,0,0,0,1.534.637s1.268.423,1.242.527.371.266,1.158.478a5.347,5.347,0,0,1,2.116,1.158c0,.18,2.087,2.247,2.087,2.458a5.278,5.278,0,0,1,.556,2.406c-.078,1.4-.159,3.185.159,3.474s0,1.427,0,1.427a.782.782,0,0,0-.026.848,7.255,7.255,0,0,1-.055,2.458l.029,2.064s-.289,1.294.052,1.349-.052.634-.052.634-.289,1.057.078,1.534a7.838,7.838,0,0,1,.475,2.51l5.66,8.225s.081,1.508-1.717,1.482-1.775.345-1.72.686-.5.715-.5.715-.712.371-.289.819,1.639,1.482-.371,2.168a4.789,4.789,0,0,1-.579-1.057,12,12,0,0,1-.423-1.427s-.185-2.012-.556-2.276-.318-1.534-.318-1.534.53-1.031-.211-1.448-11.476-6.369-11.476-6.369l-.261-7.91s-.185-5.845.926-7.8a3.286,3.286,0,0,1,.052-1.323,6.85,6.85,0,0,0-.026-2.009Z",
    transform: "translate(-239.078 -286.044)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_702",
    "data-name": "Trac\\xE9 702",
    d: "M290.094,377.251s-2.658-.547-3.373-.177-2.113.66-2.316.869-.738.055-1.216,1.3-.527,2.513-1.138,3.095-.924.979-.95,1.4.078.53-.159.66-.579.689-.478.9,5.5,4.867,5.5,4.867a12.755,12.755,0,0,0,.5,2.221c.237.449-.263,6.638-.793,7.061s3.558.388,3.558.388.185-4.053.345-4.273a41.95,41.95,0,0,0-.107-4.548,25.842,25.842,0,0,1,.318-4.681,21.043,21.043,0,0,0,.289-4.233,8.7,8.7,0,0,1,.675-2.406C291.125,379.237,290.094,377.251,290.094,377.251Z",
    transform: "translate(-202.479 -293.11)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_703",
    "data-name": "Trac\\xE9 703",
    d: "M289.822,376.978s-2.658-.547-3.373-.179-2.116.663-2.316.869-.741.052-1.216,1.3-.53,2.51-1.138,3.092-.926.979-.952,1.4.081.53-.159.663-.579.686-.475.9,5.5,4.867,5.5,4.867a12.488,12.488,0,0,0,.5,2.221c.24.449-.266,6.639-.8,7.061s3.573.385,3.573.385.185-4.053.342-4.27a42.8,42.8,0,0,0-.1-4.551,25.816,25.816,0,0,1,.318-4.679,21.313,21.313,0,0,0,.3-4.233,8.706,8.706,0,0,1,.675-2.406C290.878,378.958,289.822,376.978,289.822,376.978Z",
    transform: "translate(-202.284 -292.915)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_704",
    "data-name": "Trac\\xE9 704",
    d: "M312.272,362.753a5.358,5.358,0,0,1,.307,1.786,6.08,6.08,0,0,0,6.948-2.75,15.246,15.246,0,0,1-.261-1.972S311.134,359.392,312.272,362.753Z",
    transform: "translate(-225.013 -280.929)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_705",
    "data-name": "Trac\\xE9 705",
    d: "M298.65,340.7a6.059,6.059,0,1,0,.133-1.259A6,6,0,0,0,298.65,340.7Z",
    transform: "translate(-215.412 -263.054)",
    fill: "#ee8e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_706",
    "data-name": "Trac\\xE9 706",
    d: "M272.2,404l-1.448.449a.75.75,0,0,1-.289.793.869.869,0,0,0-.368.793s-.159.579-.53.715-.608,1-.608,1l-1.216,1.4s-.452.371-.371.556-.478.237-.478.237l.289,4.707,2.513.478,1.56-.159,1.268-.475,1.112-.663.5-1.294,2.223-3.387Z",
    transform: "translate(-192.847 -312.332)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_707",
    "data-name": "Trac\\xE9 707",
    d: "M252.225,418.718s-3.225-4.652-5.634-2.142.979,6.586,1.772,6.453,4.577-.345,4.577-.345Z",
    transform: "translate(-177.82 -320.739)",
    fill: "#ee8e9e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 16.887,
    height: 13.112,
    rx: 1.54,
    transform: "translate(67.359 88.493) rotate(27.04)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 14.195,
    height: 10.698,
    transform: "translate(68.035 90.161) rotate(27.04)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 0.232,
    cy: 0.232,
    r: 0.232,
    transform: "translate(64.886 94.441)",
    fill: "#e6e8ec"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 0.385,
    cy: 0.385,
    r: 0.385,
    transform: "translate(78.418 101.3)",
    fill: "#e6e8ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_708",
    "data-name": "Trac\\xE9 708",
    d: "M260.93,425.156c-.029,3.492,7.191,4.233,7.191,4.233l1.844.29.828.13.345-3.41s-.379-.058-.851-.168c-.7-.162-1.607-.443-1.8-.84C268.188,424.733,260.95,421.664,260.93,425.156Z",
    transform: "translate(-188.612 -326.198)",
    fill: "#ee8e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_709",
    "data-name": "Trac\\xE9 709",
    d: "M299.11,339.45a.718.718,0,0,1,.443.2c.2.217.214.6.481.735a.556.556,0,0,0,.316.035c.7-.1,1.109-.892,1.786-1.112a1.792,1.792,0,0,1,1.181.1.923.923,0,0,1,.394.252c.226.29.067.724.171,1.077.145.492.732.686,1.239.75a2.171,2.171,0,0,1,1.419.484,1.285,1.285,0,0,1,.252,1.025.8.8,0,0,0,0,.379c.139.4.825.336,1,.023.133-.229.093-.417.4-.481a1.311,1.311,0,0,1,.646.113,4.79,4.79,0,0,0,1.676.258,6.057,6.057,0,1,0-11.407-3.836Z",
    transform: "translate(-215.739 -263.066)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_710",
    "data-name": "Trac\\xE9 710",
    d: "M303.155,335.284a.8.8,0,0,1,0-.379,1.277,1.277,0,0,0-.252-1.022,2.167,2.167,0,0,0-1.419-.486c-.51-.067-1.094-.258-1.239-.75-.1-.353.055-.785-.171-1.074a.868.868,0,0,0-.394-.252,1.8,1.8,0,0,0-1.181-.1c-.677.22-1.083,1.013-1.786,1.112a.533.533,0,0,1-.316-.035c-.266-.133-.29-.518-.481-.735-.321-.339-.932-.119-1.323-.371a1.219,1.219,0,0,1-.428-.785,3.8,3.8,0,0,1-.116-1.754c.229-.981,1.109-1.656,1.668-2.5.524-.782.819-1.772,1.6-2.29a3.209,3.209,0,0,1,2.684-.139,7.573,7.573,0,0,0,1.256.33,14.14,14.14,0,0,0,2.151-.13,4.6,4.6,0,0,1,2.843.869,1.555,1.555,0,0,1,.463.469,2.435,2.435,0,0,1,.208.843,4.279,4.279,0,0,0,.559,1.546c.22.373.5.709.7,1.094a1.7,1.7,0,0,1,.191,1.254c-.069.217-.2.414-.255.637a2.4,2.4,0,0,0,.455,1.485,2.785,2.785,0,0,1,.31,1.41,1.766,1.766,0,0,1-.634,1.268,2.29,2.29,0,0,1-1.34.408,4.819,4.819,0,0,1-1.708-.258,1.346,1.346,0,0,0-.646-.113c-.31.064-.269.252-.4.481C303.98,335.62,303.3,335.681,303.155,335.284Z",
    transform: "translate(-212.106 -255.136)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_711",
    "data-name": "Trac\\xE9 711",
    d: "M308.52,462.43l3.413-2.669,5.368-5.289-1.772-.081a1.158,1.158,0,0,0-.373.724c-.026.646-1.448.043-2.192.414s-4.363,5.009-5,4.977-1.138-.321-1.4.127l-.017.029a.747.747,0,0,1-.405.24Z",
    transform: "translate(-220.733 -348.134)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_712",
    "data-name": "Trac\\xE9 712",
    d: "M290.61,457.79l1.714,5.475.269.869.816-.223,1.8-.5,8.014-2.2a6.968,6.968,0,0,0,2.9-.77,8.735,8.735,0,0,1,4.98-1.086c1.06.1,2.238-.359,3.216-2.166,0,0,2.221-6.557-3.384-8.436s-5.874,1-5.874,1l-.078.046c-.217.139-.825.579-.848,1.106-.026.646-1.448.046-2.192.414s-4.363,5.009-5,4.977-1.138-.321-1.4.13l-.017.029c-.2.269-.785.333-1.175.342a3.5,3.5,0,0,1-.365,0l-.052.014-.405.122Z",
    transform: "translate(-209.7 -343.679)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_713",
    "data-name": "Trac\\xE9 713",
    d: "M292.14,436.348l.828.13.345-3.41s-.379-.058-.851-.168A17.451,17.451,0,0,1,292.14,436.348Z",
    transform: "translate(-210.787 -332.865)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_714",
    "data-name": "Trac\\xE9 714",
    d: "M314.065,389.55s2.458-.715,1.85,6.268a19.525,19.525,0,0,1-5.156,11.4s-5.237,2.3-7.591,1.928-4.071-.449-4.071-.449a5.984,5.984,0,0,0-2.383-.634c-1.32-.052-4.1-.869-4.152-1.138s.689-4.152.371-4.441a24.508,24.508,0,0,1,4.073.417c.371.266.9.078,1.3,0a4.5,4.5,0,0,1,4.018-.206,2.44,2.44,0,0,0,1.138-.133,1.138,1.138,0,0,1,.828-.052,2.272,2.272,0,0,0,.579-.29c.078-.1.715,0,.715,0a.29.29,0,0,0,.4-.185,1.736,1.736,0,0,1,.371-.579s.712-4.018,2.061-5.527a.868.868,0,0,0,.289-.767C308.59,394.732,310.892,388.7,314.065,389.55Z",
    transform: "translate(-211.085 -302.007)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_715",
    "data-name": "Trac\\xE9 715",
    d: "M313.843,387.695s2.461-.712,1.853,6.268a19.51,19.51,0,0,1-5.156,11.4s-5.237,2.3-7.591,1.931-4.073-.457-4.073-.457a5.961,5.961,0,0,0-2.38-.634c-1.323-.055-4.1-.869-4.152-1.138s.686-4.152.371-4.444a24.541,24.541,0,0,1,4.073.42c.371.266.9.075,1.294,0a4.52,4.52,0,0,1,4.021-.208,2.413,2.413,0,0,0,1.135-.13,1.158,1.158,0,0,1,.828-.055,2.406,2.406,0,0,0,.579-.29c.078-.107.712,0,.712,0a.29.29,0,0,0,.4-.185,1.737,1.737,0,0,1,.371-.579s.715-4.018,2.064-5.527a.869.869,0,0,0,.29-.767C308.371,392.88,310.67,386.858,313.843,387.695Z",
    transform: "translate(-210.929 -300.691)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_716",
    "data-name": "Trac\\xE9 716",
    d: "M300.64,478.222l3.492,4.227.023-.023c.026-.081.371-.979.289-1.034a4.918,4.918,0,0,0-1.9-1.931,3.607,3.607,0,0,1-1.5-1.361Z",
    transform: "translate(-216.826 -364.979)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_717",
    "data-name": "Trac\\xE9 717",
    d: "M300.593,492.349l.382.217s.886-.709,1.769-1.424,1.737-1.416,1.737-1.448.371-.979.29-1.031-.223-.394-.559-.819c-2.368-.663-.869.981-.66,1.057a2.411,2.411,0,0,0-3.04,2.478A3.886,3.886,0,0,0,300.593,492.349Z",
    transform: "translate(-216.732 -371.791)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_718",
    "data-name": "Trac\\xE9 718",
    d: "M304.127,493.642l.5.29,5.1.13a10.222,10.222,0,0,0,1.807.869,1.7,1.7,0,0,0,.255.055,11.3,11.3,0,0,0,1.424.026c.391,0,.692-.026.692-.026s-.24-6.436-.423-7.113c-.087-.324-.515-.255-.938-.093a6.4,6.4,0,0,0-.915.463,16.482,16.482,0,0,0-2.51.4c-.345.185-1.323-.107-1.931,0s-1.694-.715-1.694-.715c-2.962-.979-1.294.845-1.083.926a2.41,2.41,0,0,0-3.043,2.478A2.047,2.047,0,0,0,304.127,493.642Z",
    transform: "translate(-217.345 -371.754)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_719",
    "data-name": "Trac\\xE9 719",
    d: "M336.374,491.189a8.594,8.594,0,0,0,1.714,3.859c.391,0,.692-.026.692-.026s-.24-6.436-.423-7.113c-.087-.324-.515-.255-.938-.093A7.422,7.422,0,0,0,336.374,491.189Z",
    transform: "translate(-242.212 -371.785)",
    fill: "#565387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_720",
    "data-name": "Trac\\xE9 720",
    d: "M336.374,491.189a8.594,8.594,0,0,0,1.714,3.859c.391,0,.692-.026.692-.026s-.24-6.436-.423-7.113c-.087-.324-.515-.255-.938-.093A7.422,7.422,0,0,0,336.374,491.189Z",
    transform: "translate(-242.212 -371.785)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_721",
    "data-name": "Trac\\xE9 721",
    d: "M333.149,491.365c.353,1.285.347,2.727.909,3.6a1.7,1.7,0,0,0,.255.055,11.3,11.3,0,0,0,1.424.026c.391,0,.692-.026.692-.026s-.24-6.436-.423-7.113c-.087-.324-.515-.255-.938-.093a6.392,6.392,0,0,0-.915.463A3.557,3.557,0,0,0,333.149,491.365Z",
    transform: "translate(-239.862 -371.785)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_722",
    "data-name": "Trac\\xE9 722",
    d: "M272.54,455.34a10.547,10.547,0,0,1,4.684,3.746Z",
    transform: "translate(-196.861 -348.809)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_158",
    "data-name": "Groupe 158",
    transform: "translate(81.882 72.98)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_723",
    "data-name": "Trac\\xE9 723",
    d: "M343.444,345.72a.087.087,0,0,1-.014.058,1.6,1.6,0,0,1-.09.22A2.024,2.024,0,0,1,343.444,345.72Z",
    transform: "translate(-329.046 -343.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_724",
    "data-name": "Trac\\xE9 724",
    d: "M294.022,339.983a2.262,2.262,0,0,1,.2-.533.655.655,0,0,1-.041.136,3.844,3.844,0,0,0,.119,1.754,1.228,1.228,0,0,0,.426.785c.394.252,1,.032,1.326.371.2.217.214.6.481.735a.533.533,0,0,0,.316.035c.7-.1,1.109-.892,1.786-1.112a1.778,1.778,0,0,1,1.181.1.869.869,0,0,1,.394.252c.226.29.067.721.171,1.074.145.492.732.686,1.239.75a2.157,2.157,0,0,1,1.419.486,1.277,1.277,0,0,1,.252,1.022.8.8,0,0,0,0,.379c.139.4.825.336,1,.023.133-.229.093-.417.4-.481a1.346,1.346,0,0,1,.646.113,4.821,4.821,0,0,0,1.708.258,2.29,2.29,0,0,0,1.34-.408,1.5,1.5,0,0,0,.411-.5,1.668,1.668,0,0,1-.579.9,2.29,2.29,0,0,1-1.34.408,4.822,4.822,0,0,1-1.708-.258,1.346,1.346,0,0,0-.646-.113c-.31.064-.269.252-.4.481-.182.313-.869.373-1.007-.023a.839.839,0,0,1,0-.379,1.277,1.277,0,0,0-.252-1.022,2.167,2.167,0,0,0-1.419-.486c-.51-.067-1.094-.258-1.239-.75-.1-.353.055-.785-.171-1.074a.869.869,0,0,0-.391-.252,1.8,1.8,0,0,0-1.184-.1c-.675.22-1.083,1.013-1.786,1.112a.533.533,0,0,1-.316-.035c-.266-.133-.29-.518-.481-.735-.321-.339-.929-.119-1.323-.371a1.219,1.219,0,0,1-.428-.785A3.8,3.8,0,0,1,294.022,339.983Z",
    transform: "translate(-293.966 -339.45)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_725",
    "data-name": "Trac\\xE9 725",
    d: "M339.925,411.309c-.486.654-1.039,1.259-1.468,1.948a3.709,3.709,0,0,0-.643,2.316,6.021,6.021,0,0,0,.926-1.656,23.163,23.163,0,0,1,1.781-2.672c.113-.171.842-1.158.475-1.2C340.689,410,340.09,411.086,339.925,411.309Z",
    transform: "translate(-243.233 -316.627)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_726",
    "data-name": "Trac\\xE9 726",
    d: "M345.964,593.107c.35,1.123.7,2.25,1.141,3.341a28.411,28.411,0,0,0,2.956,5.388,39.091,39.091,0,0,0,2.443,3.2c1.089,1.283,2.316,2.574,2.687,4.212a21.494,21.494,0,0,1,.24,2.9,3.543,3.543,0,0,0,1.193,2.571,4.347,4.347,0,0,0,1.96.646c.492.078,1.106.1,1.361-.321a1.236,1.236,0,0,0,.136-.562l.119-1.416c.023-.307.133-.7.44-.712s.46.394.721.579a.785.785,0,0,0,1.06-.368,1.786,1.786,0,0,0,.029-1.245,5.9,5.9,0,0,0-3.031-3.764,8.692,8.692,0,0,1-1.477-.767,5.047,5.047,0,0,1-1.158-1.465,91.063,91.063,0,0,1-7.284-13.685,10.134,10.134,0,0,1-.75-2.7,17.716,17.716,0,0,1,.116-2.849,16.213,16.213,0,0,0-.469-5.075,4.054,4.054,0,0,0-.483-1.233,2.751,2.751,0,0,0-3.764-.544,3.879,3.879,0,0,0-1.5,2.742,7.907,7.907,0,0,0,.75,2.852Q344.676,588.973,345.964,593.107Z",
    transform: "translate(-246.666 -436.479)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_727",
    "data-name": "Trac\\xE9 727",
    d: "M345.964,593.107c.35,1.123.7,2.25,1.141,3.341a28.411,28.411,0,0,0,2.956,5.388,39.091,39.091,0,0,0,2.443,3.2c1.089,1.283,2.316,2.574,2.687,4.212a21.494,21.494,0,0,1,.24,2.9,3.543,3.543,0,0,0,1.193,2.571,4.347,4.347,0,0,0,1.96.646c.492.078,1.106.1,1.361-.321a1.236,1.236,0,0,0,.136-.562l.119-1.416c.023-.307.133-.7.44-.712s.46.394.721.579a.785.785,0,0,0,1.06-.368,1.786,1.786,0,0,0,.029-1.245,5.9,5.9,0,0,0-3.031-3.764,8.692,8.692,0,0,1-1.477-.767,5.047,5.047,0,0,1-1.158-1.465,91.063,91.063,0,0,1-7.284-13.685,10.134,10.134,0,0,1-.75-2.7,17.716,17.716,0,0,1,.116-2.849,16.213,16.213,0,0,0-.469-5.075,4.054,4.054,0,0,0-.483-1.233,2.751,2.751,0,0,0-3.764-.544,3.879,3.879,0,0,0-1.5,2.742,7.907,7.907,0,0,0,.75,2.852Q344.676,588.973,345.964,593.107Z",
    transform: "translate(-246.666 -436.479)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_728",
    "data-name": "Trac\\xE9 728",
    d: "M294.417,771.406a3.86,3.86,0,0,0,1.633.2c.041-.452.648-.553,1.1-.53a1.257,1.257,0,0,1,.628.145c.113.072.2.177.31.252a1.34,1.34,0,0,0,.64.165l2.351.2a7.075,7.075,0,0,0,3.121-.2,1.077,1.077,0,0,0,.5-.336c.266-.382,0-.929-.368-1.207s-.842-.4-1.213-.686c-.816-.622-.929-1.786-1.361-2.719a8.021,8.021,0,0,0-1.126-1.63,6.261,6.261,0,0,0-1.109-1.138,5.858,5.858,0,0,0-3.135-.764,2.1,2.1,0,0,0-2.079.579c-.695.869-.417,2.606-.373,3.619A26.189,26.189,0,0,0,294.417,771.406Z",
    transform: "translate(-211.998 -567.476)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_729",
    "data-name": "Trac\\xE9 729",
    d: "M294.417,771.406a3.86,3.86,0,0,0,1.633.2c.041-.452.648-.553,1.1-.53a1.257,1.257,0,0,1,.628.145c.113.072.2.177.31.252a1.34,1.34,0,0,0,.64.165l2.351.2a7.075,7.075,0,0,0,3.121-.2,1.077,1.077,0,0,0,.5-.336c.266-.382,0-.929-.368-1.207s-.842-.4-1.213-.686c-.816-.622-.929-1.786-1.361-2.719a8.021,8.021,0,0,0-1.126-1.63,6.261,6.261,0,0,0-1.109-1.138,5.858,5.858,0,0,0-3.135-.764,2.1,2.1,0,0,0-2.079.579c-.695.869-.417,2.606-.373,3.619A26.189,26.189,0,0,0,294.417,771.406Z",
    transform: "translate(-211.998 -567.476)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_730",
    "data-name": "Trac\\xE9 730",
    d: "M285.6,629.162a1.634,1.634,0,0,0-.9,1.87,6.881,6.881,0,0,0,.947,2.047c1.048,1.873,1.5,4.016,2.38,5.97.657,1.448,1.546,2.808,2.195,4.273a7.3,7.3,0,0,1,.657,4.673c-.191.756-.562,1.448-.808,2.192a12.161,12.161,0,0,0-.475,2.475,47.014,47.014,0,0,0-.171,8.587,2.564,2.564,0,0,0,.214,1.013c.148.29.4.579.289.869-.049.119-.156.206-.208.321-.151.324.151.669.426.9a.75.75,0,0,1-.46.356,1.089,1.089,0,0,1,.463,1.213c-.243.038-.258.411-.1.608s.4.318.507.541a.756.756,0,0,1-.417.95,1.984,1.984,0,0,1-1.135.087,12.454,12.454,0,0,1-1.9-.417A1.372,1.372,0,0,1,286,666.272a21.076,21.076,0,0,1-.13-3.552c.1-5.744,0-11.494-.249-17.235a19.641,19.641,0,0,0-1.691-6.691,35.1,35.1,0,0,0-1.647-3.185c-1.291-2.362-2.432-4.98-2.137-7.658.032-.29.136-.634.423-.68a.614.614,0,0,1,.327.055,14.706,14.706,0,0,1,1.723.95A6.5,6.5,0,0,0,285.6,629.162Z",
    transform: "translate(-202.23 -470.961)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_731",
    "data-name": "Trac\\xE9 731",
    d: "M285.6,629.162a1.634,1.634,0,0,0-.9,1.87,6.881,6.881,0,0,0,.947,2.047c1.048,1.873,1.5,4.016,2.38,5.97.657,1.448,1.546,2.808,2.195,4.273a7.3,7.3,0,0,1,.657,4.673c-.191.756-.562,1.448-.808,2.192a12.161,12.161,0,0,0-.475,2.475,47.014,47.014,0,0,0-.171,8.587,2.564,2.564,0,0,0,.214,1.013c.148.29.4.579.289.869-.049.119-.156.206-.208.321-.151.324.151.669.426.9a.75.75,0,0,1-.46.356,1.089,1.089,0,0,1,.463,1.213c-.243.038-.258.411-.1.608s.4.318.507.541a.756.756,0,0,1-.417.95,1.984,1.984,0,0,1-1.135.087,12.454,12.454,0,0,1-1.9-.417A1.372,1.372,0,0,1,286,666.272a21.076,21.076,0,0,1-.13-3.552c.1-5.744,0-11.494-.249-17.235a19.641,19.641,0,0,0-1.691-6.691,35.1,35.1,0,0,0-1.647-3.185c-1.291-2.362-2.432-4.98-2.137-7.658.032-.29.136-.634.423-.68a.614.614,0,0,1,.327.055,14.706,14.706,0,0,1,1.723.95A6.5,6.5,0,0,0,285.6,629.162Z",
    transform: "translate(-202.23 -470.961)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_732",
    "data-name": "Trac\\xE9 732",
    d: "M251.046,608.724a1.877,1.877,0,0,0-2.609.3,13.911,13.911,0,0,0-1.355,1.187,7.221,7.221,0,0,0-1.61,7.145,14.074,14.074,0,0,0,1.974,3.506l1.563,2.247c2.386,3.425,4.771,6.85,7.27,10.194a.388.388,0,0,0,.272.368c.09.023.2.02.258.1a.272.272,0,0,1,.032.153,2.215,2.215,0,0,1-.139.724.344.344,0,0,0-.029.249c.081.188.423.081.533.258.072.116-.017.266-.113.365s-.214.208-.2.345.255.289.246.457c0,.1-.087.174-.148.252a.646.646,0,0,0,.078.822c.165,1.633-.724,3.185-.9,4.812-.289,2.571.883,5.081,1.025,7.661a1.983,1.983,0,0,0,.162.845c.24.446.869.715.837,1.222a4.893,4.893,0,0,1-.177.614,4.663,4.663,0,0,0,.1.869c.006.29-.252.646-.524.53q.307,1.025.547,2.067l5.472.452a4.855,4.855,0,0,0-.049-1.476c-.113-.53-.35-1.022-.475-1.546a1.83,1.83,0,0,1,.214-1.549.6.6,0,0,1-.6-.5,2.4,2.4,0,0,1,.014-.851c.145-1.427-.455-2.834-.437-4.267a20.835,20.835,0,0,1,.614-3.324c.428-2.374-.017-4.948,1.039-7.116.64-1.306,1.526-2.753.808-4.018-.353-.625-.979-1.054-1.387-1.644a6.691,6.691,0,0,1-.741-1.792,60.53,60.53,0,0,0-3.4-7.5,7.817,7.817,0,0,1-.732-1.972,10.335,10.335,0,0,1-.093-1.821,26.845,26.845,0,0,0-.2-3.268,3.109,3.109,0,0,0-.4-1.352,3.024,3.024,0,0,0-.869-.779A57.371,57.371,0,0,0,251.046,608.724Z",
    transform: "translate(-177.385 -457.506)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_733",
    "data-name": "Trac\\xE9 733",
    d: "M286.823,778.33a3.923,3.923,0,0,0,1.636.194c.041-.452.646-.553,1.1-.53a1.257,1.257,0,0,1,.628.145c.113.072.2.18.313.252a1.309,1.309,0,0,0,.64.165l2.348.2a7.046,7.046,0,0,0,3.124-.2,1.048,1.048,0,0,0,.5-.336c.266-.382,0-.926-.368-1.2s-.842-.405-1.21-.689c-.819-.622-.929-1.783-1.364-2.716a7.835,7.835,0,0,0-1.123-1.633,6.252,6.252,0,0,0-1.112-1.135,5.823,5.823,0,0,0-3.133-.767,2.1,2.1,0,0,0-2.079.579c-.695.869-.417,2.606-.376,3.622A26.233,26.233,0,0,0,286.823,778.33Z",
    transform: "translate(-206.604 -572.394)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 5.42,
    cy: 5.42,
    r: 5.42,
    transform: "translate(99.051 130.903)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_734",
    "data-name": "Trac\\xE9 734",
    d: "M328.6,561.278a5.113,5.113,0,0,1-2.91.822,18.274,18.274,0,0,0-6.262,1.812,2.259,2.259,0,0,0-.724.5,2.045,2.045,0,0,0-.368.776,5.069,5.069,0,0,0-.206,1.885,5.369,5.369,0,0,0,.524,1.772,9.554,9.554,0,0,0,3.358,3.83,2.463,2.463,0,0,0,.851.408,4.774,4.774,0,0,0,2.1-.449,3.439,3.439,0,0,1,1.943.061c.579.2,1.213.556,1.786.316a1.833,1.833,0,0,0,.808-.921,31.334,31.334,0,0,0,1.479-3.225,12.412,12.412,0,0,1,.536-1.262c.628-1.2,1.714-2.119,2.255-3.361a.738.738,0,0,0,.052-.631.869.869,0,0,0-.4-.3,9.5,9.5,0,0,1-2.166-1.7c-.356-.342-1.01-1.265-1.523-1.346C329.164,560.161,328.99,560.942,328.6,561.278Z",
    transform: "translate(-229.241 -423.346)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_735",
    "data-name": "Trac\\xE9 735",
    d: "M290.075,581.431a3.323,3.323,0,0,1-2.05.023,23.394,23.394,0,0,1-5.153-1.5,2.792,2.792,0,0,1-1.265-.973,3.185,3.185,0,0,1-.353-1.213l-.29-2.027a11.81,11.81,0,0,1,.093-2.067.6.6,0,0,0-.119-.449.489.489,0,0,0-.356-.113c-.814.014-1.306.868-1.876,1.448a3.474,3.474,0,0,1-1.158.776c-.521.214-1.158.365-1.375.886-.087.217-.075.463-.168.68-.365.869-1.919.579-2.316,1.448-.113.243-.1.547-.289.738s-.533.188-.819.234c-1.132.185-1.679,1.491-2.646,2.108a21.394,21.394,0,0,1-2.739.915,10.4,10.4,0,0,1-1.433.727,6.767,6.767,0,0,1-1.65.084.431.431,0,0,0-.327.107.437.437,0,0,0-.055.359,9.977,9.977,0,0,0,6.164,7.724,2.062,2.062,0,0,1,.527.255c.492.368.579,1.158,1.138,1.419a1.158,1.158,0,0,0,1.184-.255,10.624,10.624,0,0,0,.869-.944,3.4,3.4,0,0,1,1.908-1,4.193,4.193,0,0,0,1.966-.443,6.083,6.083,0,0,0,.62-.66,3.892,3.892,0,0,1,1.4-.84,14.354,14.354,0,0,1,4.467-.981,15.579,15.579,0,0,0,4.244-.411,2.559,2.559,0,0,0,.947-.536,2.846,2.846,0,0,0,.631-1.1,8.4,8.4,0,0,0,.278-4.421Z",
    transform: "translate(-190.589 -432.485)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_736",
    "data-name": "Trac\\xE9 736",
    d: "M323.243,573.959c.4-.038.8,0,1.2,0,.472,0,.938-.116,1.41-.119a3.506,3.506,0,0,1,3.306,2.516.651.651,0,0,1,.02.356.252.252,0,0,1-.272.185,6,6,0,0,0-.611-1.219,3.425,3.425,0,0,0-1.818-1.268,4.708,4.708,0,0,0-2.235-.081c-.31.058-.611.139-.912.223l-1.448.4c-.266.072-.536.145-.793.24-.2.075-.541.35-.738.362-.266,0-.052-.232.067-.388a1.926,1.926,0,0,1,.947-.689A8.2,8.2,0,0,1,323.243,573.959Z",
    transform: "translate(-230.743 -433.001)",
    fill: "#f18815"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_737",
    "data-name": "Trac\\xE9 737",
    d: "M335.083,595.2c.35,1.123.7,2.25,1.141,3.341a28.255,28.255,0,0,0,2.956,5.388,39.088,39.088,0,0,0,2.443,3.2,10.826,10.826,0,0,1,2.687,4.209,21.572,21.572,0,0,1,.24,2.9,3.555,3.555,0,0,0,1.19,2.571,4.441,4.441,0,0,0,1.963.646c.489.078,1.1.1,1.361-.321a1.285,1.285,0,0,0,.136-.562l.116-1.416c.026-.307.136-.7.44-.712s.463.394.724.579a.785.785,0,0,0,1.06-.368,1.8,1.8,0,0,0,.029-1.245,5.915,5.915,0,0,0-3.031-3.764,8.833,8.833,0,0,1-1.479-.767,5.011,5.011,0,0,1-1.158-1.468,90.271,90.271,0,0,1-7.284-13.685,10.211,10.211,0,0,1-.753-2.7,17.726,17.726,0,0,1,.119-2.849,16.212,16.212,0,0,0-.469-5.075,3.992,3.992,0,0,0-.486-1.233,2.748,2.748,0,0,0-3.764-.544,3.882,3.882,0,0,0-1.5,2.742,7.966,7.966,0,0,0,.75,2.852Q333.791,591.064,335.083,595.2Z",
    transform: "translate(-238.929 -437.961)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_738",
    "data-name": "Trac\\xE9 738",
    d: "M352.217,533.632c.043-.452-.362-.869-.822-1.158a10.884,10.884,0,0,1-1.393-.851c-.411-.356-.637-.819-1.048-1.175a4.658,4.658,0,0,0-1.563-.779A11.906,11.906,0,0,0,343.65,529a6.491,6.491,0,0,0-3.576.947,2.118,2.118,0,0,0-.608.579,2.485,2.485,0,0,0-.29.9,17.715,17.715,0,0,1-.935,2.84,6.611,6.611,0,0,1-1.778,2.872c-1.013.842-2.562,1.329-3.231,2.348a.753.753,0,0,0-.148.657c.1.258.4.434.686.6a9.3,9.3,0,0,1,3.793,3.63,4.213,4.213,0,0,1-.33,4.531c-.382.5-.909,1.089-.536,1.589.579.761,2.516.324,2.968,1.129a1.643,1.643,0,0,1,.058.831c0,.845.814,1.6,1.8,1.986a10.141,10.141,0,0,0,3.243.533,2.832,2.832,0,0,0,.081-2.1.845.845,0,0,1-.084-.478,1.158,1.158,0,0,1,.373-.457c1.187-1.123.935-2.774.223-4.108s-1.824-2.554-2.238-3.958a2.041,2.041,0,0,1,.347-2.061,6.964,6.964,0,0,1,1.022-.744,3.862,3.862,0,0,0,1.43-1.795c.333-.924.29-2.027,1.256-2.649.929-.579,2.235-.411,3.263-.808A3.492,3.492,0,0,0,352.217,533.632Z",
    transform: "translate(-239.862 -401.143)",
    fill: "#464353"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.8a500305.svg";
export { ForwardRef as ReactComponent };